// extracted by mini-css-extract-plugin
export default {"italic":"OHbdE","bold":"dVedX"};